import { ConnectedPosition, OverlayModule } from "@angular/cdk/overlay";
import { ChangeDetectionStrategy, Component, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { NgClass } from "@angular/common";
import { GifPreviewComponent } from "../../shared/ui/gifpreview/gifpreview";
import { GifPreview, LinkPreview } from "@teammood/timeline";
import { LinkyModule } from "@teammood/shared/util/linky";

@Component({
    selector: 'mood',
    templateUrl: './mood.component.html',
    styleUrls: ['./mood.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        NgClass,
        OverlayModule,
        GifPreviewComponent,
        LinkyModule,
    ]
})
export class MoodComponent implements OnInit {
    
    overlayPositions: ConnectedPosition[] = [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom',
        }
    ]

    @Input() value: any;
    text: string;
    protected isOpen = false;
    protected isIconClicked = false;

    constructor() {}
        
    ngOnInit() {
        let commentWithNewLines = this.value.comment;
        if (this.value.comment) {
            commentWithNewLines = this.value.comment.body.replace(/&#10;/g, '<br>');
            if (this.value.comment.linkPreviews) {
                commentWithNewLines = this.transform(commentWithNewLines, this.value.comment.linkPreviews);
            }
        }
    
        if (this.value.author) {
            if (commentWithNewLines) {
                this.text = commentWithNewLines + "<br>" + this.value.author;
            } else {
                this.text = this.value.author;
            }
        } else {
            this.text = commentWithNewLines;
        }
    }

    protected timer: any;

    toGifPreview(linkPreview: LinkPreview): GifPreview {
        return new GifPreview((linkPreview));
    }

    onMouseEnter() {
        this.isOpen = true;
        clearTimeout(this.timer);
    }

    onMouseLeave() {
        this.timer = setTimeout(() => {
            this.isOpen = false;
        }, 1200);
    }

    transform(value: string, linkPreviews: LinkPreview[] | GifPreview[]): string {
        if (!linkPreviews){
          return value;
        } else {
          return linkPreviews.filter(link => link.url.slice(-4) === ".gif").map(link => link.url).reduce((prev, curr) => {
            return prev.replace(curr, '');
          }, value);
        }
      }

   
}